import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import styles from './AlreadyRegisteredPanel.module.scss';

interface Props {
    PageData?: any;
    Model?: any;
    onClose:()=>void
}

const AlreadyRegisteredPanel = ({ PageData, Model, onClose }: Props) => {

    const loginButtonClick = ()=>{
        var tagManagerArgs = {
            dataLayer: {
              event: 'button_click',
              checkout_name: 'Registration',
              error_message: 'Already registered',
              button_name:'Login'
            }
          }
          TagManager.dataLayer(tagManagerArgs);
          window.location = Model?.VerifyIdentityViewModelWithoutReference?.LoginPageUrl;
    }
    const resetButtonClick = ()=>{
        var tagManagerArgs = {
            dataLayer: {
              event: 'button_click',
              checkout_name: 'Registration',
              error_message: 'Already registered',
              button_name:'Reset Credentials'
            }
          }
          TagManager.dataLayer(tagManagerArgs); 
          window.location = Model?.VerifyIdentityViewModelWithoutReference?.LoginResetPageUrl
    }
    return (
            <div className="modal-overlay is-active">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <a onClick={()=>onClose()} className="modal-close"></a>
                        <div className="modal-header"> {Model?.VerifyIdentityViewModelWithoutReference?.PageData?.AlreadyRegisteredHeading}</div>
                        <div className="modal-body u-center">
                            <p className="modal-para">
                    {Model?.VerifyIdentityViewModelWithoutReference?.PageData?.AlreadyRegisteredContent}
                            </p>
                            <div className="Grid">
                                <div className="Grid-cell">                                    
                                    <button type="button" className="Button u-block u-marginBxxsm w-100" onClick={loginButtonClick}>
                                        <span>{Model?.VerifyIdentityViewModelWithoutReference?.PageData?.AlreadyRegisteredLoginButtonText}</span>
                                    </button>
                                    <button type="button" className="Button u-block Button--ghost black-border w-100" onClick={resetButtonClick}>
                                        <span>{Model?.VerifyIdentityViewModelWithoutReference?.PageData?.AlreadyRegisteredResetButtonText}</span>
                                    </button>
                                
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
    )
}

export default AlreadyRegisteredPanel